import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function useSearchFlights(isIframe) {
  const navigate = useNavigate()
  const cardRefPlace = useRef()
  const cardRefPassenger = useRef()
  const cardRefDate = useRef()
  const [buttonDisable, setButtonDisable] = useState(true);
  const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [isCardRefOrigin, setIsCardRefOrigin] = useState(false)
  const [selectedOrigin, setSelectedOrigin] = useState('Origen vuelo')
  const [isCardRefDestination, setIsCardRefDestination] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState('Destino Vuelo')
  const [dateGoingSelected, setDateGoingSelected] = useState('Ida')
  const [dateReturnSelected, setDateReturnSelected] = useState('Vuelta')
  const [isCardRefDate, setIsCardRefDate] = useState(false)
  const [dateGoingSelectedApi, setDateGoingSelectedApi] = useState('')
  const [dateReturnSelectedApi, setDateReturnSelectedApi] = useState('')
  const [codeiataDestinity, setCodeiataDestinity] = useState('');
  const [codeIataOrigin, setCodeIataOrigin] = useState('');

  const [clasSelected, setClasSelected] = useState({
    economic: true,
    ejecutive: false,
    business: false
  })


  const [isManagingPassengers, setIsManagingPassengers] = useState(false)
  const [passengersSelecteds, setPassengersSelecteds] = useState({
    adult: 1,
    boy: 0,
    baby: 0
  })

  function getSelectedOrigin(value) {
    const selected = `${value?.name} - ${value?.iata}`;
    setSelectedOrigin(selected)
    setCodeiataDestinity(value?.iata)
  }

  function getSelectedDestination(value) {
    const selected = `${value?.name} - ${value?.iata}`;
    setSelectedDestination(selected)
    setCodeIataOrigin(value?.iata)
  }

  const getPassengersSelecteds = (type, operation) => {
    setPassengersSelecteds((prev) => {
      return {
        ...prev, [type]: operation ? passengersSelecteds[type] + 1 : passengersSelecteds[type] - 1
      }
    })
  }

  const finishProcess = () => {
    if (cardRefPassenger.current) {
      cardRefPassenger.current.style.display = 'none';
      setIsManagingPassengers(false)
    }
  }

  const showButtonSearch = () => {
    let isDisable = true;
    if(!isRoundTrip){
      if(
          selectedOrigin !== 'Origen vuelo'
        && selectedDestination !== 'Destino Vuelo'
        && dateGoingSelected !=='Ida')
        {
          isDisable = false;
        }
    }
    else if(isDisable && dateReturnSelected !== 'Vuelta'){
      isDisable = false
    }
    setButtonDisable(isDisable);
  }

  function ellipsisText(text, maxCaracter) {
    let result = ''
    if (text.includes("-")) {
      const textArray = text.split('-');
      const newText = `${textArray[1]} - ${textArray[0]}`;
      result = newText.length > maxCaracter
        ? newText.substring(0, maxCaracter) + '...'
        : newText;
    }
    else {
      result = text;
    }
    return result;
  }

  function searcherFlight() {
    
    const route = isIframe ? '/iframe/flight/search':'/flight/search';

    navigate(`${route}?&dateOfDeparture=${encodeURIComponent(dateReturnSelectedApi)}&dateOfReturn=${encodeURIComponent(dateGoingSelectedApi)}&iataDestinationCode=${encodeURIComponent(codeiataDestinity)}&iataOriginCode=${encodeURIComponent(codeIataOrigin)}&destinationCity=${encodeURIComponent(selectedOrigin)}&originCity=${encodeURIComponent(selectedDestination)}&adultPassengers=${encodeURIComponent(passengersSelecteds?.adult)}&boyPassengers=${encodeURIComponent(passengersSelecteds?.boy)}&babyPassengers=${encodeURIComponent(passengersSelecteds?.baby)}&isRoundTrip=${encodeURIComponent(isRoundTrip)}`,
      {
        state: {
          dateReturnSelectedApi,
          dateGoingSelectedApi,
          codeiataDestinity,
          codeIataOrigin,
          buttonOriginFlight: selectedOrigin,
          buttonDestinityFlight: selectedDestination,
          passengersSelecteds,
          roundTrip: isRoundTrip,
          // clasSelected, //no needed
          // dateGoingSelected, //no needed
          // dateSreturnSelected, //no needed
          // oneWay, //no needed
          // DestinityFlight//no needed
        }
      })
  }


  useEffect(() => {
    showButtonSearch()
  }, [isRoundTrip, dateGoingSelected, dateReturnSelected, selectedOrigin, selectedDestination]);

  useEffect(() => {
    setIsCardRefOrigin(false)
    setIsCardRefDestination(false)
  }, [selectedOrigin, selectedDestination])


  useEffect(() => {
    function handleClickOutside(event) {
      if (cardRefPlace.current && !cardRefPlace.current.contains(event.target)) {
        setIsCardRefOrigin(false)
        setIsCardRefDestination(false)
      }
      if (cardRefPassenger.current && !cardRefPassenger.current.contains(event.target)) {
        setIsManagingPassengers(false)
      }
      if (cardRefDate.current && !cardRefDate.current.contains(event.target)) {
        setIsCardRefDate(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [])

  return {
    cardRefPlace,
    cardRefPassenger,
    cardRefDate,
    isRoundTrip,
    setIsRoundTrip,
    buttonDisable,
    searcherFlight,
    //ciudades
    //ida
    isCardRefOrigin,
    setIsCardRefOrigin,
    selectedOrigin,
    getSelectedOrigin,
    //retorno
    isCardRefDestination,
    setIsCardRefDestination,
    selectedDestination,
    getSelectedDestination,
    //fechas
    dateGoingSelected,
    setDateGoingSelected,
    dateReturnSelected,
    setDateReturnSelected,
    isCardRefDate,
    setIsCardRefDate,


    setDateGoingSelectedApi,
    setDateReturnSelectedApi,


    //pasajeros
    isManagingPassengers,
    setIsManagingPassengers,
    passengersSelecteds,
    getPassengersSelecteds,
    finishProcess,
    ellipsisText
  }
}
export default useSearchFlights;